
export const RPC_URL_1 = "https://mainnet.infura.io/v3/d898563ced0345b5ad4ac9f5bc6ed301"